<template>
  <div id="header">
    <a :href="cmlUrl">
      <img id="logo" src="../../images/cml-logo.png" /> 
    </a>
    <h1 class="font-weight-bolder">Teacher Collections Request</h1>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: ['cmlUrl'],
  }
</script>

<style lang="scss" scoped>
#header{
  text-align: center;
  padding-top: 15px;
  font-family: "Montserrat", sans-serif !important;
}
#logo {
  height: 85px;
}
@media (max-width: 500px) {
  h1 {
    font-size: 1.5em;
  }
}
</style>